import React, { useState } from 'react';
import { mockSubmissions } from '../data/mockData';
import { StatusBadge } from '../components/StatusBadge';
import { FileText, Check, X, Eye, MessageSquare, ChevronDown, ChevronUp } from 'lucide-react';
export const ValidationScreen: React.FC = () => {
  const [expandedId, setExpandedId] = useState<string | null>(null);
  const [remarks, setRemarks] = useState('');
  const pendingSubmissions = mockSubmissions.filter(s => s.status === 'pending_validation');
  const toggleExpand = (id: string) => {
    setExpandedId(expandedId === id ? null : id);
    setRemarks('');
  };
  return <div className="max-w-6xl mx-auto" data-id="element-935">
      <div className="mb-6" data-id="element-936">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-937">Data Validation</h1>
        <p className="text-slate-500" data-id="element-938">
          Review and validate submitted khatian data and documents
        </p>
      </div>

      <div className="card" data-id="element-939">
        <div className="p-4 border-b border-slate-200 bg-slate-50 flex justify-between items-center" data-id="element-940">
          <h2 className="font-semibold text-slate-800" data-id="element-941">
            Pending Submissions ({pendingSubmissions.length})
          </h2>
          <div className="flex space-x-2" data-id="element-942">
            <input type="text" placeholder="Search Mouja..." className="input-field py-1 text-sm w-48" data-id="element-943" />
          </div>
        </div>

        <div className="divide-y divide-slate-200" data-id="element-944">
          {pendingSubmissions.map(sub => <div key={sub.id} className="bg-white" data-id="element-945">
              {/* Row Header */}
              <div className="p-4 flex items-center justify-between cursor-pointer hover:bg-slate-50 transition-colors" onClick={() => toggleExpand(sub.id)} data-id="element-946">
                <div className="flex items-center space-x-6" data-id="element-947">
                  <div data-id="element-948">
                    <p className="text-xs text-slate-500 font-medium" data-id="element-949">ID</p>
                    <p className="text-sm font-semibold text-slate-900" data-id="element-950">
                      {sub.id}
                    </p>
                  </div>
                  <div data-id="element-951">
                    <p className="text-xs text-slate-500 font-medium" data-id="element-952">
                      Location
                    </p>
                    <p className="text-sm text-slate-800" data-id="element-953">
                      {sub.mouja}, {sub.upazila}
                    </p>
                  </div>
                  <div data-id="element-954">
                    <p className="text-xs text-slate-500 font-medium" data-id="element-955">
                      Khatians
                    </p>
                    <p className="text-sm text-slate-800" data-id="element-956">{sub.khatianCount}</p>
                  </div>
                  <div data-id="element-957">
                    <p className="text-xs text-slate-500 font-medium" data-id="element-958">
                      Submitted By
                    </p>
                    <p className="text-sm text-slate-800" data-id="element-959">{sub.submittedBy}</p>
                  </div>
                  <div data-id="element-960">
                    <p className="text-xs text-slate-500 font-medium" data-id="element-961">Format</p>
                    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${sub.isUnicode ? 'bg-purple-100 text-purple-800' : 'bg-orange-100 text-orange-800'}`} data-id="element-962">
                      {sub.isUnicode ? 'Unicode' : 'Non-Unicode'}
                    </span>
                  </div>
                </div>
                <div className="flex items-center space-x-4" data-id="element-963">
                  <StatusBadge status={sub.status} data-id="element-964" />
                  {expandedId === sub.id ? <ChevronUp size={20} className="text-slate-400" data-id="element-965" /> : <ChevronDown size={20} className="text-slate-400" data-id="element-966" />}
                </div>
              </div>

              {/* Expanded Details */}
              {expandedId === sub.id && <div className="p-6 bg-slate-50 border-t border-slate-100" data-id="element-967">
                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-968">
                    {/* Documents Panel */}
                    <div className="col-span-2" data-id="element-969">
                      <h3 className="text-sm font-semibold text-slate-800 mb-3 uppercase tracking-wider" data-id="element-970">
                        Submitted Documents
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-971">
                        <div className="bg-white p-4 rounded-md border border-slate-200 shadow-sm flex flex-col items-center text-center" data-id="element-972">
                          <FileText size={32} className="text-blue-500 mb-2" data-id="element-973" />
                          <span className="text-sm font-medium text-slate-800 mb-1" data-id="element-974">
                            Khatian Data
                          </span>
                          <span className="text-xs text-slate-500 mb-3" data-id="element-975">
                            {sub.files.khatianData}
                          </span>
                          <button className="text-xs text-blue-600 font-medium hover:underline flex items-center" data-id="element-976">
                            <Eye size={14} className="mr-1" data-id="element-977" /> Preview Data
                          </button>
                        </div>
                        <div className="bg-white p-4 rounded-md border border-slate-200 shadow-sm flex flex-col items-center text-center" data-id="element-978">
                          <FileText size={32} className="text-red-500 mb-2" data-id="element-979" />
                          <span className="text-sm font-medium text-slate-800 mb-1" data-id="element-980">
                            Gadget Copy
                          </span>
                          <span className="text-xs text-slate-500 mb-3" data-id="element-981">
                            {sub.files.gadgetCopy}
                          </span>
                          <button className="text-xs text-blue-600 font-medium hover:underline flex items-center" data-id="element-982">
                            <Eye size={14} className="mr-1" data-id="element-983" /> View PDF
                          </button>
                        </div>
                        <div className="bg-white p-4 rounded-md border border-slate-200 shadow-sm flex flex-col items-center text-center" data-id="element-984">
                          <FileText size={32} className="text-red-500 mb-2" data-id="element-985" />
                          <span className="text-sm font-medium text-slate-800 mb-1" data-id="element-986">
                            Handover Letter
                          </span>
                          <span className="text-xs text-slate-500 mb-3" data-id="element-987">
                            {sub.files.handoverLetter}
                          </span>
                          <button className="text-xs text-blue-600 font-medium hover:underline flex items-center" data-id="element-988">
                            <Eye size={14} className="mr-1" data-id="element-989" /> View PDF
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Action Panel */}
                    <div data-id="element-990">
                      <h3 className="text-sm font-semibold text-slate-800 mb-3 uppercase tracking-wider" data-id="element-991">
                        Validation Action
                      </h3>
                      <div className="bg-white p-4 rounded-md border border-slate-200 shadow-sm" data-id="element-992">
                        <div className="space-y-3 mb-4" data-id="element-993">
                          <label className="flex items-center space-x-2 text-sm text-slate-700" data-id="element-994">
                            <input type="checkbox" className="rounded text-teal-600 focus:ring-teal-500" data-id="element-995" />
                            <span data-id="element-996">Gadget copy matches data</span>
                          </label>
                          <label className="flex items-center space-x-2 text-sm text-slate-700" data-id="element-997">
                            <input type="checkbox" className="rounded text-teal-600 focus:ring-teal-500" data-id="element-998" />
                            <span data-id="element-999">Handover letter is signed</span>
                          </label>
                          <label className="flex items-center space-x-2 text-sm text-slate-700" data-id="element-1000">
                            <input type="checkbox" className="rounded text-teal-600 focus:ring-teal-500" data-id="element-1001" />
                            <span data-id="element-1002">Mouja and JL number verified</span>
                          </label>
                        </div>

                        <div className="mb-4" data-id="element-1003">
                          <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1004">
                            Remarks (Required for Send Back)
                          </label>
                          <textarea className="input-field text-sm" rows={3} placeholder="Enter comments..." value={remarks} onChange={e => setRemarks(e.target.value)} data-id="element-1005"></textarea>
                        </div>

                        <div className="flex space-x-3" data-id="element-1006">
                          <button className="flex-1 btn-danger py-2 text-sm flex items-center justify-center" data-id="element-1007">
                            <X size={16} className="mr-1" data-id="element-1008" /> Send Back
                          </button>
                          <button className="flex-1 btn-success py-2 text-sm flex items-center justify-center" data-id="element-1009">
                            <Check size={16} className="mr-1" data-id="element-1010" /> Approve
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>)}
          {pendingSubmissions.length === 0 && <div className="p-8 text-center text-slate-500" data-id="element-1011">
              <Check size={48} className="mx-auto text-slate-300 mb-3" data-id="element-1012" />
              <p data-id="element-1013">No pending submissions to validate.</p>
            </div>}
        </div>
      </div>
    </div>;
};